// ToastContext.tsx
import { createContext, useContext, useState } from "react";

import ToastMessage, {
  ToastSeverity,
} from "../Layout/partials/ToastMessage/ToastMessage";

interface ToastState {
  open: boolean;
  severity: ToastSeverity;
  message: string;
}

const ToastContext = createContext<{
  showToast: (severity: ToastSeverity, message: string) => void;
} | null>(null);

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const [toast, setToast] = useState<ToastState>({
    open: false,
    severity: "success",
    message: "",
  });

  const showToast = (severity: ToastSeverity, message: string) => {
    setToast({ open: true, severity, message });
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastMessage
        open={toast.open}
        severity={toast.severity}
        message={toast.message}
        onClose={() => setToast((t) => ({ ...t, open: false }))}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
};
